<template>
    <!--    @notificationType="checkWithParam"-->
    <div id="feedList" v-if="!hasParams" :class="checkMobileStatus ? 'mobile-view' : 'web-view'">
        <div class="search-feed-container input-group" style="" v-show="!checkMobileStatus">
            <input class="form-control search-feed sans-font-style" type="text" placeholder="Search Moments"
                   @keyup="searchFeedWIthKeyTag($event)" v-model="searchKeyTag"/>
            <div class="input-group-append" style="cursor: pointer;" @click="loadPosts()">
                <span class="btn btn-search-feed-icon">
                    <i class="fa fa-search"></i>
                </span>
            </div>
        </div>
        <div class="feed-parent-details-container" v-show="isParent === 'Parent'">
            <div class="feed-parent-container">
                <div class="parent-details-header-container row" style="margin: 10px 0px; padding: 15px;">
                    <!--                <i class="fa fa-info-circle" aria-hidden="true" style="font-size: 20px; color: #426DFF; margin-right: 10px;"></i>-->
                    <span class="sans-font-style-size-15" style="color: #000000;">{{lang("Parent Info")}}</span>
                </div>

                <hr style="margin: 0px;" />

                <div class="parent-details-content-container row">
                    <div class="father-details-container" style="margin-bottom: 10px;"
                         v-if="parentInfo.FatherFirstName !== ''">
                    <span class="sans-font-style-size-12" style="color: #000000; display: block;">
                        <img class="common-img-icon" src="../assets/Vector15.png"/>
                        <span>{{lang("Father Name")}} : </span>
                        <span class="details-common-span">{{parentInfo.FatherFirstName}} {{parentInfo.FatherMiddleName}} {{parentInfo.FatherLastName}}</span>
                    </span>
                    </div>

                    <div class="mother-details-container"
                         v-if="parentInfo.MotherFirstName !== ''">
                    <span class="sans-font-style-size-12" style="color: #000000; display: block;">
                        <img class="common-img-icon" src="../assets/Vector15.png"/>
                        <span style="margin-right: 5px;">{{lang("Mother Name")}} : </span>
                        <span class="details-common-span">{{parentInfo.MotherFirstName}} {{parentInfo.MotherMiddleName}} {{parentInfo.MotherLastName}}</span>
                    </span>
                    </div>
                </div>
            </div>

            <div style="background: #edf0f4; height: 20px; display: block;"></div>

            <div class="feed-student-container" v-if="studentsInfo.length > 0">
                <div class="student-details-header-container row" style="margin: 10px 0px; padding: 15px;">
                    <!--                        <i class="fa fa-info-circle" aria-hidden="true" style="font-size: 20px; color: #426DFF; margin-right: 10px;"></i>-->
                    <span class="sans-font-style-size-15" style="color: #000000;">{{lang("Student Info")}}</span>
                </div>

                <hr style="margin: 0px;" />

                <div class="student-details-content-container row">
                    <div class="each-details-container"
                         v-for="studInfo in studentsInfo" v-if="studInfo.StudentCourseStatus === 'Active'">
                        <span class="sans-font-style-size-12 stud-details-span">
                            <img class="common-img-icon" src="../assets/Vector15.png"/>
                            <span>{{lang("Student Name")}} : </span>
                            <span class="details-common-span">{{studInfo.StudentFirstName}} {{studInfo.StudentMiddleName}} {{studInfo.StudentLastName}}</span>
                        </span>

                        <span class="sans-font-style-size-12 stud-details-span">
                            <img class="common-img-icon" src="../assets/Vector16.png"/>
                            <span>{{lang("Student School")}} : </span>
                            <span class="details-common-span">{{studInfo.StudentSchool}}</span>
                        </span>

                        <span class="sans-font-style-size-12 stud-details-span">
                            <img class="common-img-icon" src="../assets/Vector17.png"/>
                            <span>{{lang("Student Class")}} : </span>
                            <span class="details-common-span">{{studInfo.StudentClass}}</span>
                        </span>

                        <span class="sans-font-style-size-12 stud-details-span">
                            <img class="common-img-icon" src="../assets/Vector18.png"/>
                            <span>{{lang("Student Level")}} : </span>
                            <span class="details-common-span">{{studInfo.StudentLevel}}</span>
                        </span>
                    </div>
                </div>
            </div>

            <div class="feed-student-container" v-if="studentsInfo.length <= 0">
                <div class="student-details-header-container row" style="margin: 10px 0px; padding: 15px;">
                    <span class="sans-font-style-size-15" style="color: #000000;">{{lang("No record found")}}</span>
                </div>
            </div>
        </div>

        <div class="content-body-container">

            <div class="feed-content-container">
                <div class="row" style="margin: 0px;">
                    <div class="default-title-container" v-if="isParent !== 'Parent' && !checkMobileStatus">
                        <i class="fa fa-align-justify" style="color: #536170; margin-right: 10px; font-size: 20px;"></i>
                        <span class="sans-font-style-different-size" style="color: #536170;">{{lang("News Feed")}}</span>
                    </div>

                    <div class="new-feed-action-button" v-if="isParent !== 'Parent'" style="margin-left: auto;">
                        <button class="btn sans-font-style" style="border-radius: 5px 0px 0px 5px;"
                                @click="changePostsStatus('Self')"
                                :class="loadPostsMode === 'Self' ? 'common-button' : ''">{{lang("My Post")}}</button>

                        <button class="btn sans-font-style" style="border-radius: 0px 5px 5px 0px;"
                                @click="changePostsStatus('All')"
                                :class="loadPostsMode === 'All' ? 'common-button' : ''">{{lang("All Post")}}</button>
                    </div>

                    <div class="parent-child-list" v-if="isParent === 'Parent'">
                        <button class="btn sans-font-style" style="font-size: 12px;"
                                @click="changePostsStatus('All')"
                                :class="loadPostsMode === 'All' && displayByStudentID === '' ? 'common-button' : ''">{{lang("All Post")}}</button>

                        <!-- v-if="studInfo.StudentCourseStatus === 'Active'" -->
                        <button class="btn sans-font-style"
                                style="font-size: 12px;" v-for="(studInfo, studIndex) in studentsInfo"
                                @click="changePostsByStudent(studInfo)"
                                :class="displayByStudentID === studInfo.StudentID ? 'common-button' : ''">{{studInfo.StudentFirstName}}</button>
                        <!--<button class="btn sans-font-style" v-if="displayByStudentID"-->
                                <!--style="margin-left: auto; float: right; margin-right: 0; background: #426dff;"-->
                                <!--@click="()=>this.$router.push({ name: 'ActivityDownload', params: { studentID: this.displayByStudentID } })">-->
                            <!--download-->
                        <!--</button>-->
                    </div>

                    <div v-if="isParent === 'Parent'"
                         style="text-align: left; margin-top: 20px; width: 100%; background: #FFFFFF; padding: 0px 15px; border-radius: 6px;">
                        <span>{{lang("Filter by")}} : </span>
                        <!--                        :picker-options="datePicker"-->
                        <el-date-picker
                                style="border: none;"
                                v-model="filterByDateRange"
                                type="daterange"
                                :range-separator="lang('ETo')"
                                :start-placeholder="lang('Start Date')"
                                :end-placeholder="lang('End Date')"
                                format="dd/MM/yyyy"
                                value-format="dd/MM/yyyy"
                                @change="datePickerChange('inputEventTime')">
                        </el-date-picker>
                    </div>
                </div>

                <div class="mobile-view-search-feed" v-show="checkMobileStatus">
                    <div class="mobile-search-feed-container input-group" style="">
                        <input class="form-control search-feed sans-font-style" type="text" :placeholder="lang('Search Feed')"
                               @keyup="searchFeedWIthKeyTag($event)" v-model="searchKeyTag"/>
                        <div class="input-group-append" style="cursor: pointer;" @click="loadPosts()">
                            <span class="btn btn-search-feed-icon">
                                <i class="fa fa-search"></i>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="each-feed-list-container" v-for="(feedList, index) in list" :key="index">
                    <singleFeedComponent
                            :parent-post="feedList"
                            @commentitemSubmit="commentitemSubmit"
                            @commentEdit="commentEdit"
                            @commentDelete="commentDelete"
                            :commentPostContent="commentPostContent"
                            :PostID="commentPostID"
                            @loadPosts="loadPosts"
                            ref="pComponent"
                            @showDeleteModal="showDeleteModal"
                            @deletePost="deletePost"
                            @sendMsg="sendMsg"
                    />
                </div>

                <div class="empty-list_image" v-if="list.length <= 0 && isLoad">
                    <strong>{{empty_message}}</strong>
                    <img src="../assets/notfound.png"/>
                </div>

                <div class="lds-ellipsis" v-if="(feedLoader || isLoading) && !isLoad">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>

                <b-modal class="alert-modal" :title="lang('ARE YOU SURE')" ref="modal_DeletePost" @ok="commentDelete()">
                    {{lang("Once you delete a post, you can't undo it")}}
                </b-modal>

                <!--            for parent edit profile photo modal-->
                <b-modal id="modal_uploadProfile" title="Update Profile Picture" ref="modal_uploadProfile" centered
                         hide-footer hide-header>
                    <H5 class="mt-2 mb-4">{{lang("PROFILE")}}{{lang("PHOTO")}}</H5>
                    <div class="myaccount-image_wrap">
                        <div class="myaccount-image_overlay" @click="uploadParentProfileImg()"><i class="material-icons">
                            add_circle_outline
                        </i> {{lang("BROWSE")}}
                        </div>
                        <img v-bind:src="imgParentProfile" type="file"
                             class="imgStaffProfile"/>
                    </div>
                    <el-button type="primary" v-on:click="SaveParentProfile" round class="mt-4 mb-2">
                        <span>{{lang("Save")}}{{lang("Profile")}}{{lang("Photo")}}</span></el-button>
                    <input type="file" ref="file" accept="image/*" style="display:none" @change="previewImgParentProfile">
                </b-modal>

                <!--            New Post Modal-->
                <b-modal id="modal_NewPostModal" hide-footer size="lg" title="New Post"
                         ref="ref_modal_NewPostModal" centered v-model="isModalOpen" @hidden="hideComponentModal">
                    <component :is="obj_SelectedComponent"
                               :displayListMode="loadGalleryListMode"
                               @result="displayResult">
                    </component>
                </b-modal>

            </div>
        </div>
    </div>

    <div id="feedListWithParam" v-else-if="hasParams">

        <div class="content-body-container col-md-8">
            <div class="each-feed-list-container" v-for="(feedList, index) in list" :key="index">
                <singleFeedComponent
                        :parent-post="feedList"
                        @commentitemSubmit="commentitemSubmit"
                        @commentEdit="commentEdit"
                        @commentDelete="commentDelete"
                        :commentPostContent="commentPostContent"
                        :PostID="commentPostID"
                        @loadPosts="loadPosts"
                        ref="pComponent"
                        @showDeleteModal="showDeleteModal"
                        @deletePost="deletePost"
                        @sendMsg="sendMsg"
                />
            </div>

            <div class="empty-list_image" v-if="list.length <= 0 && isLoad">
                <strong>{{empty_message}}</strong>
                <img src="../assets/notfound.png"/>
            </div>

            <div class="lds-ellipsis" v-if="(feedLoader || isLoading) && !isLoad">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>

            <b-modal class="alert-modal" :title="lang('ARE YOU SURE')" ref="modal_DeletePost" @ok="commentDelete()">
                {{lang("Once you delete a post, you can't undo it")}}
            </b-modal>

            <!--            for parent edit profile photo modal-->
            <b-modal id="modal_uploadProfile" title="Update Profile Picture" ref="modal_uploadProfile" centered
                     hide-footer hide-header>
                <H5 class="mt-2 mb-4">PROFILE PHOTO</H5>
                <div class="myaccount-image_wrap">
                    <div class="myaccount-image_overlay" @click="uploadParentProfileImg()"><i class="material-icons">
                        add_circle_outline
                    </i> BROWSE
                    </div>
                    <img v-bind:src="imgParentProfile" type="file"
                         class="imgStaffProfile"/>
                </div>
                <el-button type="primary" v-on:click="SaveParentProfile" round class="mt-4 mb-2">
                    <span>Save Profile Photo</span></el-button>
                <input type="file" ref="file" accept="image/*" style="display:none" @change="previewImgParentProfile">
            </b-modal>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import DataSource from "../data/datasource";

    import singleFeedComponent from "../components/tempMomentsComponent";
    // import singleFeedComponent from "../components/testSingleFeedComponent";
    // import singleFeedComponent from "../components/testing1Component";
    import portfolio from "../components/Post_Portfolio_Component";
    import updates from "../components/Post_Updates_Component.vue";
    import broadcast from "../components/Post_Broadcast_Component.vue";
    // import galleryListComponent from "../components/galleryListComponent";
    import newPostComponent from "../components/newPostComponent";

    import Cookies from "js-cookie";
    import ProfileImg from "../assets/boy.png";
    import {required, minLength} from 'vuelidate/lib/validators';
    import {lang} from '../locale/index';
    import $j from 'jquery';

    import { NotifEvent, notifGlobalVariable } from '../global/index.js';

    export default {
        name: "StaffTempMoment",
        components: {
            singleFeedComponent,
            newPostComponent,
        },
        data() {
            return {
                arrobj_FolderPath: [{GalFolder: lang("Gallery"), GalID: "PRIMARY", GalType: "Folder"}],
                modalTitle: null,
                files: [],
                systemmsgError: false,
                isModalOpen: false,
                token: null,
                userType: "",
                list: [],
                error: "",
                staffPostResults: "",
                results: "",
                postContent: "",
                addPostContent: "",
                tagAcademicYearID: "",
                profolio: "No",
                tagClassID: "",
                tagLevelID: "",
                // files: [],
                content: '',
                selectedFile: null,
                success: "",
                isLoading: true,
                saveResponse: "",
                PostItemPath: "",
                tagResponseText: "123",
                academicYearTable: [],
                classesTable: [],
                levelsTable: [],
                studentTable: [],

                PostID: "",
                commentPostContent: "",
                commentPostID: "",
                actionMode: "",
                readonly: true,
                checkidcomment: "",
                toggleDeleteModal: false,
                query: '',
                tag: '',
                tags: [],
                isParent: "",

                obj_SelectedComponent: false,
                int_NumberOfPost: 10,

                arrobj_BroadcastPost: [],
                intervalCheckNew: {},
                bool_ShowRefresh: false,

                tempPost: [],
                deleteCmId: "",
                deleteCmContent: "",
                deleteCmPostId: "",

                parentInfo: [],
                studentsInfo: [],
                studentsAccordion: "",

                imgParentProfile: "",
                tempBroadcastModalPostID: [],
                loading: true,

                feedLoader: false,
                deleteType: "",
                deletePostID: "",
                empty_message: "Moments "+lang("Not Found"),

                hasParams: false,
                array_postID: [],
                arrobj_notif: [{
                    NotiValue: "",
                    NotiType: "",
                }],
                isChange: false,
                isLoad: false,

                checkMobileStatus: false,
                myPostsList: [],
                loadPostsMode: 'Self',

                loadGalleryListMode: 'Feed',
                isAllowComment: false,
                notShow: 'Portfolio,Broadcast',
                isShow: 'Update',
                searchKeyTag: '',
                displayByStudentID: '',
                singlePostID: [],
                filterByDateRange: [],

                datePicker: {
                    disabledDate(date) {
                        return date < (new Date().getTime() - (1 * 24 * 60 * 60 * 1000));
                        //  Without using the second variable, you can replace 7 for with your back x days:
                        //e.g return date< Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000));
                    }
                },
                filterFromDate: "",
                filterToDate: "",

                postTagValueEqual: "Moments",
                postTagValueNotEqual: "",
            };
        },
        filters: {
            stringify(value) {
                return JSON.stringify(value, null, 2);
            }
        },
        computed: {
            items() {
                return this.studentTable.filter(i => {
                    return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
                });
            },
        },
        created() {
            if (Cookies.get('userTypeSession') === 'Parent') {
                this.LoadParentInfo();
                this.LoadProfileImg();

                this.loadPostsMode = "All";
            }
            window.addEventListener('resize', this.isMobile);
        },
        destroyed() {
            $(window).unbind('scroll');
            // NotifEvent.$off("notificationType");
            this.$root.$off("notificationType");
            window.removeEventListener('resize', this.isMobile);
        },
        mounted() {
            if (this.$route.query.postID === undefined) {
                this.hasParams = false;
                this.loadPosts();
            } else {
                this.singlePostID = [];
                this.singlePostID.push(this.$route.query.postID);
                this.loadSinglePost();
            }

            // this.checkNotification(notifGlobalVariable);
            //
            // this.$root.$on("notificationType", (e) => {
            //     this.checkNotification(e);
            // });

            this.isMobile();

            var $this = this;

            window.history.scrollRestoration = 'manual';

            $this.connectServer();
            const self = this;
            // this.loadPosts();
            // this.loadBroadcast();

            $(document).ready(function(){
                $("#navButton .nav-search-container .search-feed-container").remove();
                if (!self.checkMobileStatus) {
                    $(".search-feed-container").appendTo("#navButton .nav-search-container");
                }

                if (!$j("#staffMainPage .left-content-container").hasClass(".feed-parent-details-container")) {
                    $j("#staffMainPage .left-content-container .feed-parent-details-container").remove();
                    $j(".feed-parent-details-container").appendTo("#staffMainPage .left-content-container");
                }

                // $(".content-body-container").css("min-height", window.outerHeight);
            });

            /*#region Scroll Loader Functions*/
            $(window).scroll(self.debounce(() => {
                if (self.getScrollPercent() >= 80 && self.list.length % 3 === 0 && self.list.length !== 0 && self.isLoad) {
                    this.isLoad = false;
                    this.feedLoader = !this.feedLoader;
                    this.isParent = Cookies.get('userTypeSession');
                    let obj_LastPost = !this.isNull(this.list) ? this.list[this.list.length - 1] : "";
                    // let promise_GetPosts = this.isParent === "Parent" ?
                    //     DataSource.shared.getParentPostFeedPage(this.int_NumberOfPost, obj_LastPost.PostID, '', this.notShow, 'All', this.isShow, '', this.searchKeyTag, this.displayByStudentID, this.filterFromDate, this.filterToDate, this.postTagValueEqual, this.postTagValueNotEqual) :
                    //     DataSource.shared.getStaffPostFeedPage(this.int_NumberOfPost, obj_LastPost.PostID, '', this.notShow, this.loadPostsMode,
                    //         this.isShow, this.searchKeyTag);
                    let promise_GetPosts = this.isParent === "Parent" ?
                        // DataSource.shared.getPortfolioMomentPostWithNewsFeed(obj_LastPost.ItemID, this.int_NumberOfPost, this.displayByStudentID, this.searchKeyTag, this.filterFromDate, this.filterToDate)
                        DataSource.shared.getParentPost(this.int_NumberOfPost, obj_LastPost.PostID, "Moment", this.filterFromDate, this.filterToDate) :
                        DataSource.shared.getStaffPostFeedPage(this.int_NumberOfPost, obj_LastPost.PostID, '', this.notShow, this.loadPostsMode,
                            this.isShow, this.searchKeyTag);

                    promise_GetPosts.then((response) => {
                        if (response.Table) {
                            this.list.push.apply(this.list, response.Table);
                        }
                        this.feedLoader = !this.feedLoader;
                        this.isLoad = true;
                    });
                }
            }, 250));
            /*#endregion*/
        },
        methods: {
            /*#region show Drop Zone Functions*/
            showDropZone() {
                $("#div_DropZone").css({
                    "visibility": "visible",
                    "opacity": "1"
                });
            },
            hideDropZone() {
                $("#div_DropZone").css({
                    "visibility": "hidden",
                    "opacity": 0
                });
            },
            /*#endregion*/

            lang,
            loadingclose() {
                this.loading = false;
            },
            showProfileModal() {
                this.$refs.modal_uploadProfile.show();
            },
            async LoadProfileImg() {
                try {
                    const staffProPic = await DataSource.shared.getStaffProfileImage();
                    // console.log("11");
                    if (staffProPic) {
                        // console.log("22");
                        if (staffProPic.code === '2') {
                            // console.log("3");
                            this.imgParentProfile = ProfileImg;
                        } else if (staffProPic.code !== '2' && staffProPic.code !== '88' && staffProPic.code !== '99') {
                            // console.log("44");
                            let image64String = this.ConvertBase64StringToImage(staffProPic.Table[0]);
                            image64String !== '' ? this.imgParentProfile = image64String : '';
                            // console.log(this.imgParentProfile, "imgParentProfile");
                        }

                    }
                } catch (e) {
                    this.result = e;
                }
            },
            async uploadParentProfileImg() {
                try {
                    this.$refs.file.click();
                } catch (e) {
                    this.results = e;
                }
            },
            previewImgParentProfile: function (event) {
                try {
                    var input = event.target;
                    if (input.files && input.files[0]) {
                        var reader = new FileReader();
                        reader.onload = (e) => {
                            this.imgParentProfile = e.target.result;
                        };
                        reader.readAsDataURL(input.files[0]);
                        this.selectedFile = event.target.files;
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async SaveParentProfile() {
                const response = await DataSource.shared.saveStaffProfileImage(this.selectedFile);
                if (response) {
                    if (response.code === '88') {
                        window.location.replace('/');
                    } else if (response.code === "1") {
                        this.$notify({
                            title: 'Success',
                            message: 'Records Successfully Saved',
                            type: 'success'
                        });
                        this.$refs.modal_uploadProfile.hide();
                    } else {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Save Parent Error - Please try again later'
                        });
                    }
                }
            },
            ConvertBase64StringToImage(file) {
                if (this.isImage(file))
                    return "data:" + file.UPPImageFileType + ";base64," + file.UPPImage;
                else
                    return '';
            },
            isImage(obj_File) {
                let ext = String(obj_File.UPPImageFileExt).toUpperCase();
                let isImage = false;

                switch (ext) {
                    case ".PNG":
                    case ".JPG":
                    case ".BMP":
                    case ".GIF":
                        isImage = true;
                        break;
                    default:
                        isImage = false;
                        break;
                }
                return isImage;
            },
            showDeleteModal(deleteCmId, deleteCmContent, deleteCmPostId, post) {
                this.$refs.modal_DeletePost.show();
                this.tempPost = post;
                this.deleteCmId = deleteCmId;
                this.deleteCmContent = deleteCmContent;
                this.deleteCmPostId = deleteCmPostId;
                this.deleteType = "comment";
            },
            deletePost(post) {
                this.$refs.modal_DeletePost.show();
                this.deleteType = "post";
                this.deletePostID = post.PostID;
            },
            CheckNew() {
                this.isParent = Cookies.get('userTypeSession');

                let promise_GetPosts = this.isParent === "Parent" ?
                    DataSource.shared.getParentPostFeedPage(1, null, '', this.notShow)
                    : DataSource.shared.getStaffPostFeedPage(1, null, '', this.notShow, this.loadPostsMode);

                promise_GetPosts.then((response) => {
                    if (response.Table && (new Date(response.Table[0].PostCreatedDate)) > (new Date(this.list[0].PostCreatedDate))) {
                        this.bool_ShowRefresh = true;
                        clearInterval(this.intervalCheckNew);
                    }
                });
            },

            showMoreBroadcastModal() {
                this.$refs.modal_ShowMoreBroadcast.show();
            },
            showBroadcastReadMore(Post) {
                this.tempBroadcastModalPostID = Post;
                this.$refs.modal_broadcastReadMore.show();
            },
            isNull(obj) {
                return (obj === null || obj === undefined || obj === "undefined" || obj.length === 0 || obj === "");
            },

            /*#region Scroll Loader Functions*/
            getScrollPercent() {
                //Credits to Phil Ricketts @ stackoverflow
                let height = document.documentElement,
                    body = document.body,
                    scrollTop = 'scrollTop',
                    scrollHeight = 'scrollHeight';

                return (height[scrollTop] || body[scrollTop]) / ((height[scrollHeight] || body[scrollHeight]) - height.clientHeight) * 100;
            },
            isScrollable() {
                return $(document).height() > $(window).height();
            },
            debounce(func, wait, immediate) {
                // Returns a function, that, as long as it continues to be invoked, will not
                // be triggered. The function will be called after it stops being called for
                // N milliseconds. If `immediate` is passed, trigger the function on the
                // leading edge, instead of the trailing.
                let timeout, result;
                let self = this;

                let later = function (context, args) {
                    timeout = null;
                    if (args) result = func.apply(context, args);
                };

                let debounced = self.restArguments(function (args) {
                    if (timeout) clearTimeout(timeout);
                    if (immediate) {
                        let callNow = !timeout;
                        timeout = setTimeout(later, wait);
                        if (callNow) result = func.apply(this, args);
                    } else {
                        timeout = self.delay(later, wait, this, args);
                    }

                    return result;
                });

                debounced.cancel = function () {
                    clearTimeout(timeout);
                    timeout = null;
                };

                return debounced;
            },
            delay(func, wait, ...args) {
                // Lodash Delay
                /**
                 * Invokes `func` after `wait` milliseconds. Any additional arguments are
                 * provided to `func` when it's invoked.
                 *
                 * @since 0.1.0
                 * @category Function
                 * @param {Function} func The function to delay.
                 * @param {number} wait The number of milliseconds to delay invocation.
                 * @param {...*} [args] The arguments to invoke `func` with.
                 * @returns {number} Returns the timer id.
                 * @example
                 *
                 * delay(text => console.log(text), 1000, 'later')
                 * // => Logs 'later' after one second.
                 */
                if (typeof func != 'function') {
                    throw new TypeError('Expected a function');
                }
                return setTimeout(func, +wait || 0, ...args);
            },
            restArguments(func, startIndex) {
                // Some functions take a variable number of arguments, or a few expected
                // arguments at the beginning and then a variable number of values to operate
                // on. This helper accumulates all remaining arguments past the function?s
                // argument length (or an explicit `startIndex`), into an array that becomes
                // the last argument. Similar to ES6?s "rest parameter".
                startIndex = startIndex == null ? func.length - 1 : +startIndex;
                return function () {
                    let length = Math.max(arguments.length - startIndex, 0),
                        rest = Array(length),
                        index = 0;
                    for (; index < length; index++) {
                        rest[index] = arguments[index + startIndex];
                    }
                    switch (startIndex) {
                        case 0:
                            return func.call(this, rest);
                        case 1:
                            return func.call(this, arguments[0], rest);
                        case 2:
                            return func.call(this, arguments[0], arguments[1], rest);
                    }
                    let args = Array(startIndex + 1);
                    for (index = 0; index < startIndex; index++) {
                        args[index] = arguments[index];
                    }
                    args[startIndex] = rest;
                    return func.apply(this, args);
                };
            },
            /*#endregion*/

            loadPosts() {
                this.$vs.loading();
                // this.showSession()
                // user menu
                this.feedLoader = !this.feedLoader;

                $("html, body").animate({scrollTop: 0}, "fast");
                this.bool_ShowRefresh = false;
                this.isParent = Cookies.get('userTypeSession');
                this.list = [];
                // let promise_GetPosts = this.isParent === "Parent" ?
                //     DataSource.shared.getParentPostFeedPage(this.int_NumberOfPost, '', '', this.notShow, 'All', this.isShow, '', this.searchKeyTag, this.displayByStudentID, this.filterFromDate, this.filterToDate, this.postTagValueEqual, this.postTagValueNotEqual)
                //     : DataSource.shared.getStaffPostFeedPage(this.int_NumberOfPost, '', '', this.notShow, this.loadPostsMode,
                //         this.isShow, this.searchKeyTag);
                let promise_GetPosts = this.isParent === "Parent" ?
                    // DataSource.shared.getPortfolioMomentPostWithNewsFeed('', this.int_NumberOfPost, this.displayByStudentID, this.searchKeyTag, this.filterFromDate, this.filterToDate)
                    DataSource.shared.getParentPost(this.int_NumberOfPost, null, "Moment", this.filterFromDate, this.filterToDate)
                    : DataSource.shared.getStaffPostFeedPage(this.int_NumberOfPost, '', '', this.notShow, this.loadPostsMode,
                        this.isShow, this.searchKeyTag);

                promise_GetPosts.then((response) => {
                    if (response.Table)
                        this.list.push.apply(this.list, response.Table);

                    this.isLoading = false;
                    this.feedLoader = !this.feedLoader;

                    this.isLoad = true;

                    this.$vs.loading.close();
                  if (this.list.length > 0) {
                    console.log("check")
                    this.checkUpdateNotifStatus(this.list[0].PostID);
                  }
                });
            },
          checkUpdateNotifStatus(postID) {
            if (this.isParent === "Parent") {
              this.list.forEach(object => {
                if (object.PostID === postID) {
                  this.updateNotifStatus(object);
                }
              });
            }
          },

          async updateNotifStatus(obj) {
            if (obj.PostRead === "No") {
              const updatedNotifStatus = await DataSource.shared.updateNotificationsStatus(obj.NotiID, "MarkAsRead");

              if (updatedNotifStatus.code === '1') {
                // console.log("success notif");
                this.list.forEach(object => {
                  if (object.PostID === obj.PostID) {
                    object.PostRead = "Yes";
                  }
                });
              } else {
                console.log("fail notif");
              }
            }
          },
            connectServer() {
                var $this = this;
                var conn = $.hubConnection(process.env.VUE_APP_ROOT_API, {qs: "clientId=1232222"});

                $this.proxy = conn.createHubProxy("PostingHub");
                conn.start({jsonp: true});
                $this.getMsg();
            },
            sendMsg(postId, comment) {
                var $this = this;
                $this.proxy.invoke("Send", postId, comment).done((msg) => {
                });
            },
            getMsg() {
                var $this = this;

                $this.proxy.on("broadcastMessage", (postId, comment) => {
                    var pComp = $this.$refs.pComponent;

                    for (var l = 0; l < pComp.length; l++) {
                        if (pComp[l]._props.parentPost.PostID == postId) {
                            pComp[l].getBCMsg(postId);
                            break;
                        }
                    }
                });
            },

            loadBroadcast() {

                this.isParent = Cookies.get('userTypeSession');
                this.arrobj_BroadcastPost = [];

                let promise_GetPosts = this.isParent === "Parent" ?
                    DataSource.shared.getParentPost(10, null, "BROADCAST")
                    : DataSource.shared.getStaffPost(10, null, "BROADCAST");

                promise_GetPosts.then((response) => {
                    if (response.Table)
                        this.arrobj_BroadcastPost.push.apply(this.arrobj_BroadcastPost, response.Table);
                });


            },
            hideComponentModal() {
                this.obj_SelectedComponent = false;
                this.isModalOpen = false;
                this.modalTitle = null;
            },
            displayResult(value) {
                //TODO: Show Message
                if (value === "TRUE") {
                    this.hideComponentModal();
                    this.loadPosts();
                } else {
                    this.hideComponentModal();
                }
            },
            showUpdates() {
                this.modalTitle = "Post";
                this.obj_SelectedComponent = updates;
                this.isModalOpen = true;
            },
            showPortfolio() {
                this.modalTitle = "Portfolio";
                this.obj_SelectedComponent = portfolio;
                this.isModalOpen = true;
            },
            showBroadcast() {
                this.modalTitle = "Broadcast";
                this.obj_SelectedComponent = broadcast;
                this.isModalOpen = true;
            },
            inputChange(input) {
                this.postContent = input;
            },
            showModal() {
                this.isModalOpen = true;
            },
            hideModal() {
                this.isModalOpen = false;
            },
            onFileChanged(event) {
                this.selectedFile = event.target.files;
                this.getImagePreviews();
            },
            async onSubmit() {
                this.$v.$touch();
                this.error = "";
                //this.results = "<< Requesting.. >>";
                try {
                    let allowComment = "";
                    if (this.isAllowComment) {
                        allowComment = "Yes";
                    } else {
                        allowComment = "No";
                    }

                    const studentsIds = this.tags.map(d => d.Student_ID);
                    const saveResponse = await DataSource.shared.savePostUpdate(this.selectedFile, this.addPostContent, studentsIds, this.tagClassID, this.tagLevelID, this.PostID, allowComment);

                    if (saveResponse) {
                        switch (saveResponse.code) {
                            case "1":
                                this.isModalOpen = false;
                                // reset all input filed to blank
                                this.selectedFile = null;
                                this.$refs.fileupload.value = "";
                                this.addPostContent = "";
                                this.tagAcademicYearID = null;

                                this.tagLevelID = null;
                                this.tagClassID = null;
                                this.results = `Post Submitted`;
                                this.success = 'Post Submitted, activity will be active in a while';
                                break;
                            case "88":
                                this.results = `Please Login to submit post`;
                                this.systemmsgError = true;
                                break;
                            case "99":
                                this.results = `Please fill in content`;
                                this.systemmsgError = true;
                                break;
                            // default:
                            //     alert("Please try again later");
                            //     this.results = JSON.stringify(response);
                        }
                    }
                } catch (e) {
                    console.log(e);
                    this.error = e;
                }
            },
            async commentitemSubmit(postId, comment) {
                this.error = "";
                this.isChange = false;
                //this.results = "<< Requesting.. >>";
                try {

                    this.commentPostID = postId;
                    const commentResponse = await DataSource.shared.saveComment(this.commentPostID, comment);
                    this.sendMsg(this.commentPostID, comment);
                    this.isChange = true;
                    // if (commentResponse) {
                    //     switch (commentResponse.code) {
                    //         case "1":
                    //             // this.sendMsg(this.commentPostID, comment);
                    //             break;
                    //         case "88":
                    //             this.results = `Please Login to submit post`;
                    //             this.systemmsgError = true;
                    //             break;
                    //         case "99":
                    //             this.results = `Please fill in content`;
                    //             this.systemmsgError = true;
                    //             break;
                    //     }
                    // }

                } catch (e) {
                    console.log(e);
                    this.error = e;
                }
            },
            async commentEdit(PoCmID, PoCmContent) {
                this.error = "";
                try {
                    this.actionMode = "Edit";
                    const commentResponse = await DataSource.shared.editComment(PoCmID, PoCmContent, this.actionMode);
                    if (commentResponse) {
                        switch (commentResponse.code) {
                            case "1":
                                // reset all input filed to blank
                                this.commentPostID = null;
                                this.commentPostContent = "";
                                this.readonly = true;

                                this.sendMsg(PoCmID, PoCmContent);
                                // const newComment = await DataSource.shared.getComment(PoCmID);
                                this.list.find(item => {

                                    if (item.PostID === PoCmID) {
                                        item.commentItems = newComment.Table;
                                        // this.sendMsg(PoCmID, PoCmContent);
                                        return item;
                                    }

                                });
                                break;
                            case "88":
                                this.results = `Please Login to submit post`;
                                this.systemmsgError = true;
                                break;
                            case "99":
                                this.results = `Please fill in content`;
                                this.systemmsgError = true;
                                break;
                        }
                    }
                } catch (e) {
                    console.log(e);
                    this.error = e;
                }
            },
            async commentDelete() {
                if (this.deleteType === "comment") {
                    let PoCmID = this.deleteCmId;
                    let PoCmContent = this.deleteCmContent;
                    let postId = this.deleteCmPostId;
                    this.error = "";
                    try {
                        this.actionMode = "Delete";
                        const deleteCommentResponse = await DataSource.shared.deleteComment(PoCmID, PoCmContent, this.actionMode);
                        if (deleteCommentResponse) {
                            switch (deleteCommentResponse.code) {
                                case "1":
                                    // reset all input filed to blank
                                    this.commentPostID = null;
                                    this.commentPostContent = "";

                                    //     const newComment = await DataSource.shared.getComment(PoCmID);

                                    this.list.find(item => {

                                        if (item.PostID === postId) {
                                            item.commentItems = item.commentItems.filter(comment => comment.PoCmID !== PoCmID);
                                            this.sendMsg(postId, PoCmContent);
                                            return item;
                                        }

                                    });
                                    //  this.$forceUpdate();
                                    break;
                                case "88":
                                    this.results = `Please Login to submit post`;
                                    this.systemmsgError = true;
                                    break;
                                case "99":
                                    this.results = `Please fill in content`;
                                    this.systemmsgError = true;
                                    break;
                            }
                        }
                    } catch (e) {
                        console.log(e);
                        this.error = e;
                    }
                } else if (this.deleteType === "post") {

                    DataSource.shared.softDeletePost(this.deletePostID).then((result) => {
                    });
                    this.loadPosts();
                }
            },
            async disableReadonly(PoCmID) {
                this.error = "";
                try {
                    this.readonly = false;
                    this.checkidcomment = PoCmID;
                } catch (e) {
                    console.log(e);
                    this.error = e;
                }
            },
            getImagePreviews() {
                /*
                  Iterate over all of the files and generate an image preview for each one.
                */
                for (let i = 0; i < this.selectedFile.length; i++) {
                    /*
                      Ensure the file is an image file
                    */
                    if (/\.(jpe?g|png|gif)$/i.test(this.selectedFile[i].name)) {
                        /*
                          Create a new FileReader object
                        */
                        let reader = new FileReader();

                        /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */
                        reader.addEventListener("load", function () {
                            this.$refs['image' + parseInt(i)][0].src = reader.result;
                        }.bind(this), false);

                        /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
                        reader.readAsDataURL(this.selectedFile[i]);
                    }
                }
            },
            clearPreview() {
                this.selectedFile = null;
            },
            async LoadParentInfo() {
                try {
                    if (Cookies.get('userIDSession') !== null || Cookies.get('userIDSession') !== undefined) {

                        const response = await DataSource.shared.getParentStudentsInfo(Cookies.get('userIDSession'));
                        if (response) {
                            if (response.code === "2") {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'No record found'
                                });
                            } else if (response.code === "99") {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Please try again later'
                                });
                            } else {
                                this.parentInfo = response.Parent[0];
                                this.studentsInfo = response.Students;
                                // console.log(this.parentInfo, "parentInfo");
                                // console.log(this.studentsInfo, "studentsInfo");
                            }
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
            },

            async loadSinglePost() {
                this.feedLoader = !this.feedLoader;

                $("html, body").animate({scrollTop: 0}, "fast");
                this.bool_ShowRefresh = false;
                this.isParent = Cookies.get('userTypeSession');
                this.list = [];

                // this.array_postID = NotiValue.split(',');
                // this.array_postID = JSON.stringify(this.array_postID);

                const singlePostData = await DataSource.shared.getPostByPostID(JSON.stringify(this.singlePostID));

                this.list.push.apply(this.list, singlePostData.Table);

                this.isLoading = false;
                this.feedLoader = !this.feedLoader;

                // this.hasParams = true;
            },
            checkWithParam(NotiValue) {
                if (!this.isNull(NotiValue)) {
                    this.hasParams = true;
                    this.loadSinglePost(NotiValue);
                } else {
                    this.hasParams = false;
                    this.loadPosts();
                }
            },
            checkNotification(notif) {
                if (this.isNull(notifGlobalVariable.NotiValue)) {
                    this.hasParams = false;
                    this.loadPosts();
                } else {
                    if (notifGlobalVariable.NotiType === "Update" || notifGlobalVariable.NotiType === "FeedComment") {
                        this.checkWithParam(notifGlobalVariable.NotiValue);
                    } else {
                        this.$set(notifGlobalVariable, "NotiValue", notif.NotiValue);
                        this.$set(notifGlobalVariable, "NotiType", notif.NotiType);
                    }
                }
            },

            isMobile() {
                let screenWidth = window.innerWidth;
                if (screenWidth <= 770) {
                    this.checkMobileStatus = true;
                    // return true;
                } else {
                    this.checkMobileStatus = false;
                    // return false;
                }
            },

            changePostsStatus(mode) {
                this.loadPostsMode = mode;
                this.displayByStudentID = "";
                this.searchKeyTag = "";
                this.loadPosts();
            },

            showNewPost() {
                this.obj_SelectedComponent = newPostComponent;
                this.isModalOpen = true;
            },

            searchFeedWIthKeyTag(event) {
                if (event.keyCode === 13) {
                    this.loadPosts();
                }
            },

            changePostsByStudent(studInfo) {
                this.displayByStudentID = studInfo.StudentID;
                this.loadPosts();
            },

            datePickerChange() {
                this.filterFromDate = "";
                this.filterToDate = "";

                if (this.filterByDateRange !== null) {
                    this.filterFromDate = this.filterByDateRange[0];
                    this.filterToDate = this.filterByDateRange[1];
                }

                this.loadPosts();
            },
        },
        validations: {
            updateContent: {
                required
                // minLength: minLength(4)
            }
        },
        computed: {
            filteredBroadcastPost: function () {
                return this.arrobj_BroadcastPost.slice(0, 3);
            },
        },
    }
</script>

<style scoped>
    .content-body-container {
        /*display: inline-block;*/
        margin: 0 auto;
        padding: 20px;
        /*background: white;*/
        /*background: #edf0f4;*/
    }

    ::-webkit-input-placeholder { /* Edge */
        color: #91A3B6;
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #91A3B6;
    }

    ::placeholder {
        color: #91A3B6;
    }

    .search-feed {
        font-size: 14px;
        background: #F8FAFF;
        border: 1px solid #E1E6F0;
        box-sizing: border-box;
        border-radius: 8px;
        border-right: none;
    }

    .search-feed:focus {
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .btn-search-feed-icon {
        font-size: 14px;
        background: #F8FAFF;
        border: 1px solid #E1E6F0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #426DFF;
        border-left: none;
    }

    .parent-details-content-container,
    .student-details-content-container {
        margin: 10px 0px;
        padding: 15px;
        text-align: left;
    }

    .student-details-content-container {
        height: 300px;
        overflow: auto;
    }

    .each-details-container {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        margin-bottom: 15px;
        padding: 5px;
    }

    .stud-details-span {
        color: #000000;
        display: block;
        margin-bottom: 5px;
    }

    .common-img-icon {
        vertical-align: baseline;
        margin-right: 10px;
    }

    .details-common-span {
        font-weight: bold;
        display: block;
        margin-left: 20px;
    }

    .student-details-content-container::-webkit-scrollbar {
        background-color: #fff;
        width: 8px;
    }

    .student-details-content-container::-webkit-scrollbar-thumb {
        background-color: #426DFF;
    }

    .student-details-content-container::-webkit-scrollbar-track {
        background-color: #ffffff;
    }

    .sans-font-style-size-12 {
        font-family: sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
    }

    .sans-font-style {
        font-family: sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
    }

    .sans-font-style-size-15 {
        font-family: sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 15px;
        line-height: 18px;
    }

    .sans-font-style-size-18 {
        font-family: sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 22px;
    }

    .sans-font-style-different-size {
        font-family: sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 22px;
        line-height: 28px;
    }

    /* Web Css */
    .web-view .feed-content-container {
        /*width: 450px;*/
        /*width: 600px;*/
        /*width: auto;*/
        width: 80%;
        margin: 0 auto;
    }

    /*.web-view .feed-profile-student-cover {*/
    /*    height: 200px;*/
    /*    width: 100%;*/
    /*    object-fit: cover;*/
    /*}*/

    /*.web-view .feed-profile-student-profile {*/
    /*    height: 100px;*/
    /*    width: 100px;*/
    /*    position: absolute;*/
    /*    top: 70px;*/
    /*    !*border: 1px solid black;*!*/
    /*    border-radius: 50%;*/
    /*    left: 50px;*/
    /*    z-index: 10;*/
    /*    overflow: hidden;*/
    /*    background: #FFFFFF;*/
    /*}*/

    /*.web-view .imgStaffProfile {*/
    /*    max-width: none;*/
    /*    height: 100px;*/
    /*    width: 100px;*/
    /*}*/

    /*.web-view .feed-profile-student-profile > button {*/
    /*    position: absolute;*/
    /*    width: 100%;*/
    /*    display: flex;*/
    /*    background: #23222f9e;*/
    /*    border: 0px;*/
    /*    height: 50%;*/
    /*    bottom: 0;*/
    /*    justify-content: center;*/
    /*    align-content: flex-start;*/
    /*    flex-wrap: wrap;*/
    /*    transition: all 0.3s ease-in-out;*/
    /*    cursor: pointer;*/
    /*    opacity: 0;*/
    /*}*/

    /*.web-view .feed-profile-student-profile > button:hover {*/
    /*    opacity: 1;*/
    /*}*/

    .new-feed-action-button {
        text-align: left;
    }

    .new-feed-action-button button {
        background: #91A3B6;
        color: #FFFFFF;
        padding: 6px 20px;
    }

    .new-feed-action-button button.common-button {
        background: #426DFF;
    }

    .feed-list-header-container {
        text-align: left;
        margin: 20px 0px;
    }

    .feed-list-header-container > span {
        margin-right: 10px;
        display: inline-block;
        vertical-align: middle;
    }

    .feed-list-header-container > label {
        font-weight: normal;
        font-size: 12px;
    }

    .each-feed-list-container,
    .myposts-each-feed-list-container {
        margin-bottom: 20px;
    }

    .profile-student__wrapper .myaccount-image_wrap {
        width: auto;
        height: auto;
        left: 0px;
        margin: unset;
        top: -70px;
    }

    .profile-student-desc {
        width: 80%;
        text-align: left;
        display: unset;
    }

    .profile-student-desc span {
        white-space: normal;
        display: inline-block;
        margin-right: 20px;
    }

    .mobile-parent-profile {
        margin-bottom: 40px;
    }

    .mobile-parent-profile .profile-student__wrapper {
        padding-top: unset;
    }

    .mobile-parent-profile .profile-student__wrapper .container {
        height: 40px;
        display: unset;
        margin: unset;
    }

    .mobile-parent-profile .profile-student__wrapper .container .myaccount-image_wrap {
        width: 60px;
        height: 60px;
        top: 5px;
        display: inline-block;
        max-width: 20%;
    }

    .mobile-parent-profile .profile-student__wrapper .container .myaccount-image_wrap img {
        width: 40px;
        height: 40px;
    }

    .mobile-parent-profile .profile-student__wrapper .container .profile-student-desc {
        display: inline-block;
        max-width: 75%;
        vertical-align: top;
    }

    .mobile-parent-profile .profile-student__wrapper .container .profile-student-desc .fatherName,
    .mobile-parent-profile .profile-student__wrapper .container .profile-student-desc .motherName {
        display: block;
    }

    .mobile-parent-profile .profile-student__wrapper .container .profile-student-desc .fatherName span,
    .mobile-parent-profile .profile-student__wrapper .container .profile-student-desc .motherName span,
    .mobile-parent-profile .profile-student__wrapper .container .profile-student-desc .fatherName strong,
    .mobile-parent-profile .profile-student__wrapper .container .profile-student-desc .motherName strong{
        font-size: 12px;
        margin-right: 5px;
    }

    .mobile-view .search-feed-container {
        margin-top: 20px;
    }

    .mobile-view .mobile-search-feed-container {
        margin-top: 20px;
    }

    .mobile-view .new-feed-action-button {
        width: 100%;
    }

    .mobile-view .new-feed-action-button button {
        width: 50%;
        padding: 15px 0px;
        background: #ffffff;
        color: #426DFF;
    }

    .mobile-view .new-feed-action-button button.common-button {
        width: 50%;
        padding: 15px 0px;
        background: #D3D9E8;
        color: #536170;
    }

    .parent-child-list {
        text-align: left;
    }

    .parent-child-list button {
        background: #91A3B6;
        color: #FFFFFF;
        padding: 6px 20px;
        margin-right: 15px;
    }

    .parent-child-list button.common-button {
        background: #426DFF;
    }

    .mobile-view .parent-child-list {
        text-align: left;
    }

    .mobile-view .parent-child-list button {
        background: #D3D9E8;
        color: #536170;
        padding: 6px 20px;
    }

    .mobile-view .parent-child-list button.common-button {
        background: #FFFFFF;
        color: #426DFF;
    }

    @media (max-width: 450px) {
        #modal_uploadProfile .myaccount-image_wrap {
            margin: 0;
        }

        .content-body-container {
            /*padding: 20px 0;*/
            padding: 0px;
        }

        .feed-list-header-container {
            text-align: center;
            margin-bottom: 5px;
        }

        .default-title-container {
            padding: 10px;
        }
    }

    @media (max-width: 769px) {
        #modal_uploadProfile .myaccount-image_wrap {
            margin: 0;
        }

        .content-body-container {
            /*padding: 20px 0;*/
            padding: 0px;
        }

        .feed-list-header-container {
            text-align: center;
            margin-bottom: 5px;
        }

        .default-title-container {
            padding: 10px;
        }
    }
</style>

<style>
    .feedPageBTabs .nav-tabs .nav-link.active {
        background-color: #dee2e6;
        border-color: #dee2e6 #dee2e6;
    }

    #feedList .el-date-editor .el-range-separator {
        width: auto;
    }
</style>